import { Config } from './types';

export const productionUrl: Config = {
  API_URL: 'https://pallet.pesantisrl.it',
};
